// hides new anagram link
$(document).ready(  function() {
  $('#new_anagram_link').hide();
});

